import { render } from "./Descution.vue?vue&type=template&id=6275217d"
import script from "./Descution.vue?vue&type=script&lang=js"
export * from "./Descution.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__